import AddIcon from "@mui/icons-material/Add";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { misc } from "app/themes/colors";
import { Insurer } from "services/types/insurers.type";

type PolicyInsurerListItemProps = {
  props: object;
  option: Insurer;
  search: string;
  isNew?: boolean;
};

export default function PolicyInsurerListItem({
  props,
  search,
  option,
  isNew = false,
}: PolicyInsurerListItemProps) {
  return (
    <ListItem
      {...props}
      key={option.id}
      sx={{
        mb: 0.5,
      }}
      data-testid="master-product-item"
    >
      <Stack
        spacing={2}
        direction="row"
        justifyContent="space-between"
        alignContent="center"
      >
        <ListItemText
          disableTypography={!isNew}
          primaryTypographyProps={
            isNew ? { fontWeight: "fontWeightBold" } : undefined
          }
          secondary={
            <Stack
              direction="row"
              sx={{ color: misc.grayAsphalt, mt: 0.5 }}
              spacing={1.5}
            >
              {option.id === -1 && (
                <Typography sx={{ pt: 0.25 }}>
                  {search.length
                    ? `Add "${search}" as new Insurer`
                    : `Add new Insurer`}
                </Typography>
              )}
              {option.id !== -1 && (
                <Typography sx={{ pt: 0.25 }}>
                  Payer ID: {option.payer_id}
                </Typography>
              )}
            </Stack>
          }
        >
          {option.name &&
            (option.verified
              ? option.name
              : option.payer_name
              ? `${option.name ?? ""} (${option.payer_name})`
              : option.name)}
          {!option.is_active && " (Inactive)"}
        </ListItemText>
        {isNew && (
          <ListItemIcon>
            <AddIcon />
          </ListItemIcon>
        )}
      </Stack>
    </ListItem>
  );
}
